import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const OperatorMcpConnectionsCreate = lazy(() =>
  import("@scenes/OperatorMcpConnections").then((module) => ({
    default: module.OperatorMcpConnectionsCreate,
  }))
);

export const operatorMcpConnectionsCreateNRO: NavigationRoutingObject = {
  Component: OperatorMcpConnectionsCreate,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) => t("operator-mcp-connections-heading", "Operator MCP Connections"),
  icon: "nav-system-technology-partners",
  pageNameForTracking: () => "Operator MCP Connections Create",
  // Adding a connection needs editTechnologyPartners too; the page shows that, as the endpoint enforces it.
  // Same rule as the endpoints and useCanUseOperator: the useOperator permission applies only with its flipper on.
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) =>
    featureOn("sage_ai_agentic_mcp_connections") &&
    (!featureOn("fix_granular_permission_use_operator") ||
      hasPermission("appGroup", { permission: "useOperator" })),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/operator_mcp_connections/:appGroupId",
};
